import React from 'react';
interface Partner {
  name: string;
  src: string;
  imgClass: string;
}
const partners: Partner[] = [{
  name: 'Invesco',
  src: 'https://cdn.magicpatterns.com/uploads/gbMX8W4UHDn3Cok5vHQEoQ/IVZ_BIG-50c3392f.png',
  imgClass: 'max-h-8 sm:max-h-9'
}, {
  name: 'Fidelity Investments',
  src: 'https://cdn.magicpatterns.com/uploads/7Eyo5wBZhga9RcRR9qN9zy/png-clipart-logo-fidelity-investments-investor-business-corporation-business-text-people.png',
  imgClass: 'max-h-9 sm:max-h-10'
}, {
  name: 'Progressive',
  src: 'https://cdn.magicpatterns.com/uploads/2FA1cJMSiBKsoGMTSx3YDM/PROGRESSIVE.png',
  imgClass: 'max-h-6 sm:max-h-7'
}, {
  name: 'Rocket Mortgage',
  src: 'https://cdn.magicpatterns.com/uploads/fQmmhDSYRDx3PVhETnpLY6/Rocket-Mortgage-Logo-768x432.png',
  imgClass: 'max-h-12 sm:max-h-14'
}];
export function Partners() {
  return <section className="w-full bg-ivory py-24 sm:py-32 lg:py-40" aria-labelledby="partners-title" data-id="element-163" data-mp="35yrl5eszzdpd">
      <div className="mx-auto max-w-page px-5 sm:px-10 lg:px-12" data-id="element-164" data-mp="16r66nqclr4ev">
        <div className="mx-auto max-w-2xl text-center" data-id="element-165" data-mp="12oj7139owf74">
          <h2 id="partners-title" className="font-sans text-[1.6rem] font-light uppercase leading-[1.15] text-ink sm:text-[2.1rem]" data-id="element-166" data-mp="12q45v531ekas">
            Compañías con las que trabajamos
          </h2>
          <p className="mt-6 font-sans text-base font-light leading-relaxed text-steel sm:text-[17px]" data-id="element-167" data-mp="1bneeeiogzvc0">
            Acceso a compañías reconocidas del sector y a diferentes soluciones
            de acuerdo con las necesidades de cada persona o familia.
          </p>
        </div>

        <ul className="mx-auto mt-14 grid max-w-4xl grid-cols-2 gap-x-10 gap-y-10 sm:mt-16 sm:gap-x-14 lg:grid-cols-4 lg:gap-x-16" data-id="element-168" data-mp="1ze0lo7qnhbky">
          {partners.map(partner => <li key={partner.name} className="flex h-24 items-center justify-center border border-ink/8 bg-white/50 px-6 sm:h-28" data-id="element-169" data-mp="51k96p79h17n">
              <img src={partner.src} alt={partner.name} className={`w-auto max-w-full object-contain ${partner.imgClass}`} data-id="element-170" data-mp="204gwpt78lyoj" />
            </li>)}
        </ul>
      </div>
    </section>;
}